module.exports = __webpack_public_path__ + "img/alfie-m5.5976c952.jpeg";